<div mwePreserveFocus>
  <div class="text-center" data-force-focus="front">
    <p [attr.data-test]="getTestId('arbeitspreis-label')" class="mb-0">
      {{ selectedPriceIndication().arbeitspreisLabel }}
    </p>
    @if (isSpotTariff()) {
      <div class="d-flex justify-content-center">
        <mwe-info-text [infoTextCode]="infoText().infoTextCode" [customUrlOverride]="selectedPriceIndication().produktUrl ?? ''">
          <a
            [attr.href]="selectedPriceIndication().produktUrl"
            target="_blank"
            [attr.data-test]="getTestId('indexKey')"
            class="fs-5 fw-bold text-secondary-light mb-0 lh-1 text-decoration-underline"
          >
            {{ 'tariff.selectionCard.spot.indexKey' | translate }}
          </a>
        </mwe-info-text>
      </div>
      <p class="text-secondary fw-bold" [attr.data-test]="getTestId('arbeitspreis-unit')">
        {{ 'tariff.selectionCard.spot.today' | translate }}: {{ spotTariffPrice() }}
      </p>
    } @else {
      <p [attr.data-test]="getTestId('arbeitspreis-value')" class="fs-2 fw-bold text-secondary mb-0 lh-1">
        {{ selectedPriceIndication().arbeitspreisZahlbar }}
      </p>
      @if (!selectedPriceIndication().arbeitspreisSubtext) {
        <p [attr.data-test]="getTestId('arbeitspreis-unit')" class="fw-semibold text-secondary">
          {{ selectedPriceIndication().arbeitspreisUnit }}
        </p>
      }
      @if (selectedPriceIndication().arbeitspreisSubtext) {
        <p [attr.data-test]="getTestId('arbeitspreis-unit')">
          {{ selectedPriceIndication().arbeitspreisSubtext }}
        </p>
      }
    }
  </div>
  <hr />

  <div class="mb-3" role="list">
    <mwe-tariff-selection-card-ui-row [attr.data-test]="getTestId('grundpreis')" [isReadOnly]="true">
      <div class="d-flex" slot="left">
        <p
          [attr.data-test]="getTestId('grundpreis-label')"
          [attr.id]="getTestId('grundpreis-label')"
          class="fw-semibold text-secondary mb-0"
        >
          {{ selectedPriceIndication().grundpreisLabel }}:
        </p>
        @if (selectedPriceIndication().grundpreisIconInfoText) {
          <mwe-info-text-icon
            [infoTextDescription]="selectedPriceIndication().grundpreisIconInfoText"
            [infoTextTitle]="selectedPriceIndication().grundpreisLabel"
          >
          </mwe-info-text-icon>
        }
      </div>
      <ng-container slot="right">
        <p
          [attr.data-test]="getTestId('grundpreis-value')"
          class="{{ selectedPriceIndication().grundpreisSubtext ? 'fw-semibold text-secondary' : '' }} mb-0"
        >
          {{ selectedPriceIndication().grundpreisZahlbar }} {{ selectedPriceIndication().grundpreisUnit }}
        </p>
        @if (selectedPriceIndication().grundpreisSubtext) {
          <p class="mb-0">{{ selectedPriceIndication().grundpreisSubtext }}</p>
        }
      </ng-container>
    </mwe-tariff-selection-card-ui-row>

    @for (item of groups(); track $index) {
      <mwe-tariff-selection-card-ui-row [isReadOnly]="item.isReadOnly" [attr.data-test]="getTestId(item.id)">
        <ng-container slot="left">
          @let testId = getTestId(item.id + '-label');
          @if ($first && compositionText()) {
            <mwe-info-text [infoTextDescription]="compositionText()" [infoTextTitle]="item.label">
              <p class="fw-semibold text-secondary mb-0" [attr.id]="testId" [attr.data-test]="testId">{{ item.label }} :</p>
            </mwe-info-text>
          } @else {
            <p class="fw-semibold text-secondary mb-0" [attr.id]="testId" [attr.data-test]="testId">{{ item.label }} :</p>
          }
        </ng-container>
        <ng-container slot="right">
          <mwe-tariff-option-dropdown
            [options]="item.options"
            [selectedTariffOptionId]="item.selectedTariffOptionId"
            [selectedTariffGroupId]="item.id"
            [selectedTariffKey]="selectedTariff().tariffKey"
            [isReadonly]="item.isReadOnly"
            [ariaLabelledBy]="getTestId(item.id + '-label')"
            (optionSelected)="onOptionSelected(item, $event)"
          />
        </ng-container>
      </mwe-tariff-selection-card-ui-row>
    }
  </div>
  <hr />
  <div class="mb-3" role="list">
    @for (label of advantages(); track $index) {
      <div class="mb-2 row gx-2" role="listitem" [attr.data-test]="getTestId('vorteile')">
        <div class="col-auto">
          <div class="green-check vertical-center">
            <i class="fas fa-check text-center fw-normal" aria-hidden="true"></i>
          </div>
        </div>
        <div class="col align-self-center">
          <p class="fw-semibold text-secondary mb-0">{{ label }}</p>
        </div>
      </div>
    }
  </div>

  @if (selectedPriceIndication().aktionsHinweis) {
    <div class="mb-2 row gx-2" [attr.data-test]="getTestId('available-campaign-hint')">
      <div class="col-auto">
        <div
          class="d-flex align-items-center justify-content-center rounded-pill text-white text-center bg-warning text-warning-dirty"
          style="width: 1.5rem; height: 1.5rem; font-size: 0.75rem"
        >
          <i class="fa fa-gift text-center fw-normal" aria-hidden="true"></i>
        </div>
      </div>
      <div class="fw-semibold text-secondary col">
        {{ selectedPriceIndication().aktionsHinweis }}
      </div>
    </div>
  }

  @if (selectedPriceIndication().tarifInformationen?.tarifLabel) {
    <mwe-infobox type="info">
      <p class="fw-bold text-secondary mb-0" [translate]="selectedPriceIndication().tarifInformationen.tarifLabel"></p>
    </mwe-infobox>
  }

  @for (item of activeCampaignTexts(); track $index) {
    <div class="mb-3 row gx-2" [attr.data-test]="getTestId('active-campaign')">
      <mwe-infobox [titleKey]="item.aktionsLabel" headingNodeType="p" type="success" iconClassOverwrite="fas fa-gift">
        <p class="mb-0" [translate]="item.aktionsDetails"></p>
      </mwe-infobox>
    </div>
  }
</div>
<div [attr.data-test]="getTestId('legal-text')" class="text-center text--legal mt-3">
  {{ selectedPriceIndication().rechtsTextGueltig }}
</div>
